import { formatDate } from "@/filters";
export const mutations = {
  SET_LIST: (state, items) => {
    state.list = items.map(item => {
      item['date'] = formatDate(item['date_start'], 'YYYY-MM-DD');
      return item;
    });
  },
};